(() => {
  const root = document.querySelector('.klaviyo-form-SYDkPR');
  if (!root) return;
  const repeated = /Join our texts for 15% off, plus first access to new releases and private sales\./i;
  const simplify = () => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (repeated.test(node.nodeValue)) {
        node.nodeValue = node.nodeValue.replace(repeated, 'Get first access to new releases, restocks, and private sales.');
      }
    }
  };
  simplify();
  new MutationObserver(simplify).observe(root, { childList: true, subtree: true, characterData: true });
})();